import { Button, Modal } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { IRecipient } from '@nkr/models/recipient';
import useEpletGraphData from '@nkr/store/recipient/hooks/use-eplet-graph-data';
import EpletMmGraph from './eplet-mm-graph';
import { styles } from './styles';

interface IProps {
    show: boolean,
    recipient: IRecipient,
    onClose: () => void
}

const EpletMmGraphModal = (props: IProps) => {
    const { show, recipient } = props;
    const { data, loading, error } = useEpletGraphData(show ? recipient?.id : null, { cache: true });

    const renderBody = () => {
        if (loading) {
            return (
                <div style={styles.loading}>
                    <ReactLoading type={'spin'} color={'black'} />
                </div>
            );
        }

        if (error) {
            return <div style={styles.message}>{error}</div>;
        }

        if (data == null) {
            return null;
        }

        if (!data.hasMismatchCount) {
            return <div style={styles.message}>No eplet mismatch data is available for this recipient.</div>;
        }

        return <EpletMmGraph graphData={data} recipient={recipient} />;
    };

    return (
        <Modal backdrop='static' bsSize='large' show={show} onHide={props.onClose}>
            <Modal.Header closeButton />

            <Modal.Body>
                {renderBody()}
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={props.onClose}>Dismiss</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EpletMmGraphModal;
